import { useEffect, useContext } from "react";
import { Switch, Route, useHistory, Redirect } from "react-router-dom";
import { UserContext } from "../components/context/UserContext";
import { useSelector } from "react-redux";
const PrivateRoutes = (props) => {
  const account = useSelector((state) => state.user.account);
  const history = useHistory();

  console.log("===>User login:", account.auth, "Path:", props.path);
  if (
    account.auth === true ||
    props.path === "/register" ||
    props.path === "/"
  ) {
    return (
      <>
        <Route path={props.path} component={props.component} />
      </>
    );
  } else {
    return <Redirect to="/login" />;
  }
};
export default PrivateRoutes;
